import { Col, Row, Table, Typography } from "antd"
import React from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { QuestionCircleOutlined } from "@ant-design/icons"
import moment from "moment/moment"
import useInteractiveTableFilters from "../../../components/Filters/InteractiveFilters"
import TapeTechnicalReqDetails from "./TapeTechnicalReqDetails"
import useTapeTechnicalRequests from "../../../store/Designer/useTapeTechnicalRequests"

const { Text, Link } = Typography

const filterConfig = [
  { key: "client", dataIndex: "client" },
  { key: "product", dataIndex: ["product", "productName"] },
  { key: "filterGroup", dataIndex: "filterGroup" },
]

export default function TechnicalRequests() {
  const { loading: tapeTechnicalLoading, technicalRequests } = useTapeTechnicalRequests()

  const [appliedFilters, setAppliedFilters, generateFilters] = useInteractiveTableFilters(
    technicalRequests,
    filterConfig
  )

  //Controls the state of columns
  const columns = [
    {
      title: "Clients",
      dataIndex: "client",
      filters: generateFilters("client", "client"),
      onFilter: (value, record) => record.client === value,
      filterSearch: true,
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      filters: generateFilters("product", "productName"),
      filterSearch: true,
      onFilter: (value, record) => record.product.productName === value,
    },
    {
      title: "Width (mm)",
      dataIndex: "tapeWidth",
      sorter: (a, b) => a.tapeWidth - b.tapeWidth,
    },
    {
      title: "Machine",
      dataIndex: "machine",
      sorter: (a, b) => a.machine - b.machine,
    },
    {
      title: "Material",
      dataIndex: "material",
      sorter: (a, b) => a.material - b.material,
    },
    {
      title: "Manager Attachment",
      dataIndex: ["product", "productFileUrl"],
      align: "center",
      render: (value) => (
        <Link type="text" rel="noreferrer" target="_blank" href={value}>
          {value ? "Link" : ""}
        </Link>
      ),
    },
    {
      title: "Details",
      align: "center",
      render: (value) => <TapeTechnicalReqDetails priceData={value} />,
    },

    {
      title: "Created",
      dataIndex: "created",
      sorter: (a, b) => a.created.seconds - b.created.seconds,
      render: (value) => (
        <>
          <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
        </>
      ),
    },
  ]

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader
            appliedFilters={appliedFilters}
            text="Tape technical Requests"
            icon={<QuestionCircleOutlined />}
          />
        </Col>
        <Col span={24}>
          <Table
            size="small"
            rowKey={(record) => record.id}
            pagination={{ defaultPageSize: "30" }}
            onChange={(pagination, filters) => {
              setAppliedFilters({
                client: filters.client || [],
                product: filters.product || [],
                filterGroup: filters.filterGroup || [],
              })
            }}
            dataSource={technicalRequests && technicalRequests}
            loading={tapeTechnicalLoading}
            columns={columns}
          />
        </Col>
      </Row>
    </div>
  )
}
